export { VirtualProviderGroupDetails } from './VirtualProviderGroupDetails';
